import { createContext, ReactNode, useContext } from "react";

import { appConfig } from "../../appConfig";
import { useIdentityToken } from "../../hooks/useIdentityToken/useIdentityToken";
import type { RdmMessage } from "../../hooks/useSharedRdmWebsocket/rdmMessage.types";
import { useSharedRdmWebsocket } from "../../hooks/useSharedRdmWebsocket/useSharedRdmWebsocket";

export const RdmMessageContext = createContext<RdmMessage | null>(null);

export const RealtimeRdmProvider = ({ children }: { children: ReactNode }) => {
  const token = useIdentityToken();
  const { lastMessage } = useSharedRdmWebsocket(
    appConfig.deviceApiWsUrl,
    token,
  );

  return (
    <RdmMessageContext.Provider value={lastMessage}>
      {children}
    </RdmMessageContext.Provider>
  );
};

export function useRdmMessage(): RdmMessage | null {
  return useContext(RdmMessageContext);
}
